const BookTextColor = {
  WHITE: 'white',
  BLACK: 'black',
};

module.exports = BookTextColor;
